import { useSelector } from "react-redux";
import type { State } from "@App/state";
import { useEffect } from "react";
import { Services } from "@App/types/enums";

export function RedirectToMC() {
  const fleetVehicleReturn = useSelector((state: State) => state.fleet.vehicleReturn);
  const authorizedReturnLocationIds = fleetVehicleReturn?.authorizedReturnLocationIds;
  const vrEncoded = Buffer.from(JSON.stringify(fleetVehicleReturn), "utf-8").toString("base64");

  // biome-ignore lint/correctness/useExhaustiveDependencies: Run this only once on mount
  useEffect(() => {
    if (!authorizedReturnLocationIds) return;
    if (authorizedReturnLocationIds.length === 0) {
      window.location.href = `/partner/mobility-concept/werkstaetten?service=${Services.VEHICLERETURN}&vehicleReturn=${vrEncoded}`;
    }
  }, []);
  return null;
}
